/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PaymentGateway_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.PaymentGateway domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PaymentGateway_ {
   /// <summary>
   ///   Other (Other)
   /// </summary>
   Other = 0,
   /// <summary>
   ///   PayPal Payflow Pro API (PayPal)
   /// </summary>
   PayPalPayflowPro = 1,
   /// <summary>
   ///   Skipjack Transaction Network (Skipjack)
   /// </summary>
   SkipjackTxNet = 2,
   /// <summary>
   ///   Forte Payment Systems (Forte)
   /// </summary>
   Forte = 3,
   /// <summary>
   ///   ROAM Mobile Commerce Gateway (ROAM)
   /// </summary>
   ROAM = 4,
   /// <summary>
   ///   PayPal Checkout (PPc/o)
   /// </summary>
   PayPalCheckout = 5,
   /// <summary>
   ///   Braintree Payments ([B])
   /// </summary>
   Braintree = 6,
   /// <summary>
   ///   PayPal Here SDK (PPH)
   /// </summary>
   PayPalHere = 7
}

export const PaymentGateways: PaymentGateway[] = [
   {
      code: PaymentGateway_.Other,
      literal: 'Other',
      description: 'Other',
      shortDescription: 'Other',
      listPriority: 0,

      typeName: "PaymentGateway"
   },
   {
      code: PaymentGateway_.PayPalPayflowPro,
      literal: 'PayPalPayflowPro',
      description: 'PayPal Payflow Pro API',
      shortDescription: 'PayPal',
      listPriority: 0,

      typeName: "PaymentGateway"
   },
   {
      code: PaymentGateway_.SkipjackTxNet,
      literal: 'SkipjackTxNet',
      description: 'Skipjack Transaction Network',
      shortDescription: 'Skipjack',
      listPriority: 0,

      typeName: "PaymentGateway"
   },
   {
      code: PaymentGateway_.Forte,
      literal: 'Forte',
      description: 'Forte Payment Systems',
      shortDescription: 'Forte',
      listPriority: 0,

      typeName: "PaymentGateway"
   },
   {
      code: PaymentGateway_.ROAM,
      literal: 'ROAM',
      description: 'ROAM Mobile Commerce Gateway',
      shortDescription: 'ROAM',
      listPriority: 0,

      typeName: "PaymentGateway"
   },
   {
      code: PaymentGateway_.PayPalCheckout,
      literal: 'PayPalCheckout',
      description: 'PayPal Checkout',
      shortDescription: 'PPc/o',
      listPriority: 0,

      typeName: "PaymentGateway"
   },
   {
      code: PaymentGateway_.Braintree,
      literal: 'Braintree',
      description: 'Braintree Payments',
      shortDescription: '[B]',
      listPriority: 0,

      typeName: "PaymentGateway"
   },
   {
      code: PaymentGateway_.PayPalHere,
      literal: 'PayPalHere',
      description: 'PayPal Here SDK',
      shortDescription: 'PPH',
      listPriority: 0,

      typeName: "PaymentGateway"
   }
]

export class PaymentGateway implements IDomainModel {
   code: PaymentGateway_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PaymentGateway_): PaymentGateway {
      return PaymentGateways.find(d => d.code === code)
   }
}
